import { Carousel } from '@mantine/carousel'
import { rem } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { IconArrowLeft, IconArrowRight } from '@tabler/icons-react'
import ProductCardNew from '../features/buyer/product/ProductCardNew'
import { IProduct } from '../interfaces/buyer/product/IProductResponse'
import classes from './customCarousel.module.css'
import ProductInfoSkeleton from './skeletons/ProductInfoSkeleton'

interface ICarouselProps {
	loading: boolean
	products: IProduct[]
}

const CustomCarousel = ({ loading, products }: ICarouselProps) => {
	const isMobile = useMediaQuery(`(max-width: 480px)`)
	return (
		<>
			<Carousel
				nextControlIcon={
					<IconArrowRight
						style={{
							width: rem(30),
							height: rem(30),
							boxShadow: '5px 5px 10px 2px rgba(0,0,0,.4)',
							borderRadius: '100px',
						}}
					/>
				}
				previousControlIcon={
					<IconArrowLeft
						style={{
							width: rem(30),
							height: rem(30),
							boxShadow: '5px 5px 10px 2px rgba(0,0,0,.4)',
							borderRadius: '100px',
						}}
					/>
				}
				slideSize={isMobile ? '160px' : '160px'}
				slideGap={isMobile ? 0 : 10}
				align='start'
				dragFree
				classNames={classes}
			>
				{loading
					? [1, 2, 3, 4, 5, 6, 7].map((_, index) => (
							<Carousel.Slide key={index}>
								<ProductInfoSkeleton />
							</Carousel.Slide>
					  ))
					: products?.map((product, index) => {
							return (
								<Carousel.Slide key={index}>
									<ProductCardNew product={product} />
								</Carousel.Slide>
							)
					  })}
			</Carousel>
		</>
	)
}

export default CustomCarousel
